import { IViewport } from "@config/appConfig";
import { Culture } from "@core/index";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import { getBeautyTime } from "@utilize/Format";
import { FC, useState } from "react";
import { useSelector } from "react-redux";

interface IBeautyDateProps {
    date: number;
    format: string;
}

const BeautyDate: FC<IBeautyDateProps> = (props) => {
    const { date, format } = props;
    const dateTime = Culture.getDateTimeInstance();
    const nowDateTime = Culture.getDateTimeInstance();
    const [beautyDate, setBeautyDate] = useState<boolean>(true);
    const { width } = useSelector((state: IAppState) => ({ width: state.windowWidth }));
    dateTime.setTime(date);

    return (
        width <= Config.get<IViewport>("viewport").large ?
            <div className="beauty-date" onClick={() => setBeautyDate(!beautyDate)}>
                {
                    beautyDate ?
                        getBeautyTime(nowDateTime.getTime(), date, format) : dateTime.format(format)
                }
            </div>
            :
            <div className="beauty-date" title={dateTime.format(format)}>{getBeautyTime(nowDateTime.getTime(), date, format)}</div>

    );
}

export default BeautyDate;
